<template>
	<div class="app-container">


		<el-tabs v-model="activeIndex" type="border-card" v-tab-change:activeIndex="setActiveName">
			<!-- 视频列表 -->
			<el-tab-pane label="视频列表" name="0">
				<videoCourseListView />
			</el-tab-pane>

			<!-- 视频标签 -->
			<el-tab-pane label="视频标签" name="1">
				<video-course-tab-list-view />
			</el-tab-pane>
		</el-tabs>

	</div>
</template>

<script>
	import videoCourseListView from "@/views/mai/videoCourse/videoCourseList"
	import videoCourseTabListView from "@/views/mai/videoCourse/videoCourseTabList"

	export default {

		components: {
			videoCourseListView,
			videoCourseTabListView
		},
    data(){
      return{
        activeIndex:"0"
      }
    }
	};
</script>

<style scoped lang="scss"></style>
